var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" }
    },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            "before-close": _vm.handleClose,
            title: "Edit Location",
            width: "94%"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Title", prop: "title" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.title,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "title", $$v)
                  },
                  expression: "form.title"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-8" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Address", prop: "address" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.address,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "address", $$v)
                        },
                        expression: "form.address"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-4" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Phone", prop: "phone" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.phone,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "phone", $$v)
                        },
                        expression: "form.phone"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "Website", prop: "website" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.website,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "website", $$v)
                  },
                  expression: "form.website"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-4" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "Primary Category",
                      prop: "primary_category"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "" },
                        model: {
                          value: _vm.primary_category_id,
                          callback: function($$v) {
                            _vm.primary_category_id = $$v
                          },
                          expression: "primary_category_id"
                        }
                      },
                      _vm._l(_vm.GMBCategories, function(category) {
                        return _c("el-option", {
                          key: category.name,
                          attrs: {
                            label: category.displayName,
                            value: category.name
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-8" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "Additional Categories",
                      prop: "categories"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { multiple: "", filterable: "" },
                        model: {
                          value: _vm.categories_ids,
                          callback: function($$v) {
                            _vm.categories_ids = $$v
                          },
                          expression: "categories_ids"
                        }
                      },
                      _vm._l(_vm.GMBCategories, function(category) {
                        return _c("el-option", {
                          key: category.name,
                          attrs: {
                            label: category.displayName,
                            value: category.name
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "Description", prop: "description" } },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 6 },
                model: {
                  value: _vm.form.description,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "description", $$v)
                  },
                  expression: "form.description"
                }
              })
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("Cancel")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("Save")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }